import axios from 'axios';

export const hasAcceptedNewTermsAndConditions = async (newTermsLabel) => {
  const response = await axios.get(`/seller/accept-terms/${newTermsLabel}`);
  return response.status === 204 ? true : (response?.data ?? true);
};

export const acceptNewTermsAndConditions = async (newTermsLabel) => {
  await axios.put(`/seller/accept-terms/${newTermsLabel}`);
};
